import { call, put, takeEvery } from 'redux-saga/effects';
import { IProspectApiResponse, prospectActionCreators, ProspectsActionKeys, UpdateProspect } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import * as api from '../prospectsApi';

function* updateProspectSaga(action: UpdateProspect) {
  const response: IApiExecuteRespone<IEntityWithMessages<IProspectApiResponse>> = yield call(
    api.UpdateProspect,
    action.payload
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(prospectActionCreators.updateProspectFulfilled(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }
}

export function* watchUpdateProspect() {
  yield takeEvery(ProspectsActionKeys.UPDATE_PROSPECT, updateProspectSaga);
}
